// extracted by mini-css-extract-plugin
export var cloud = "stars-module--cloud--Jfd0T";
export var stars = "stars-module--stars--lVMgC";
export var wrapper = "stars-module--wrapper---Z8UF";